import React, { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore/lite";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  InputGroup,
} from "react-bootstrap";
import SVCashClosingSummary from "./SVClashClosingSummary";

export default function SVCashClosingForm({ fecha, turno, tickets, usuario }) {
  const [formData, setFormData] = useState({
    ingresosTotales: "0.00",
    ingresosEfectivo: "0.00",
    ingresosTarjeta: "0.00",
    cambioInicial: "0.00",
    cambioFinal: "0.00",
    totalCaja: "0.00",
    comentarios: "",
    descuadre: false,
  });
  const [hasLastReport, setHasLastReport] = useState(false);
  const [lastReport, setLastReport] = useState({});

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      ingresosTarjeta: formatToTwoDecimals(
        tickets.reduce((acc, compra) => acc + (compra.Amount || 0), 0)
      ),
      ingresosTotales: formatToTwoDecimals(
        tickets.reduce((acc, compra) => acc + (compra.Amount || 0), 0)
      ),
    }));
  }, [tickets]);

  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const getLastReport = async () => {
      const path = `Fila12/Sales/${fecha}/Time/${turno}Reports/1`;
      const docRef = doc(getFirestore(), path);

      const snapshot = await getDoc(docRef);
      const dataReport = snapshot.data();

      if (dataReport) {
        setHasLastReport(true);
        setLastReport(dataReport);
      } else {
        setHasLastReport(false);
        setFormData((prev) => ({
          ...prev,
          ingresosTotales: "0.00",
          ingresosEfectivo: "0.00",
          ingresosTarjeta: "0.00",
          cambioInicial: "0.00",
          cambioFinal: "0.00",
          totalCaja: "0.00",
        }));
      }
    };
    getLastReport(fecha, turno);
  }, [fecha, turno]);

  // --- Funció per mantenir sempre dos decimals ---
  const formatToTwoDecimals = (value) => {
    if (value === "" || isNaN(value)) return "0.00";
    return parseFloat(value).toFixed(2);
  };

  const toNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    // aceptar coma o punto como separador decimal
    const cleaned = String(v).replace(",", ".");
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (!formData.descuadre && type === "number") {
      mantenercoherencia(name, value);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]:
          type === "checkbox"
            ? checked
            : name === "comentarios"
            ? value
            : formatToTwoDecimals(value),
      }));
    }
  };

  const mantenercoherencia = (name, value) => {
    if (name === "ingresosEfectivo") {
      setFormData((prev) => ({
        ...prev,
        ingresosEfectivo: value,
        ingresosTarjeta: formatToTwoDecimals(formData.ingresosTotales - value),
        cambioFinal: formatToTwoDecimals(
          toNumber(formData.cambioInicial) +
            toNumber(value) -
            toNumber(formData.totalCaja)
        ),
      }));
    }
    if (name === "ingresosTarjetaXXX") {
      setFormData((prev) => ({
        ...prev,
        ingresosTarjeta: value,
        ingresosEfectivo: formatToTwoDecimals(formData.ingresosTotales - value),
        cambioFinal: formatToTwoDecimals(
          toNumber(formData.cambioInicial) +
            toNumber(formData.ingresosTotales) -
            toNumber(value) +
            toNumber(formData.totalCaja)
        ),
      }));
    }
    if (name === "cambioFinalXXX") {
      setFormData((prev) => ({
        ...prev,
        cambioFinal: value,
        ingresosEfectivo: formatToTwoDecimals(
          toNumber(value) - toNumber(formData.cambioInicial)
        ),
        ingresosTarjeta: formatToTwoDecimals(
          toNumber(formData.ingresosTotales) -
            (toNumber(value) - toNumber(formData.cambioInicial))
        ),
      }));
    }
    if (name === "cambioInicial") {
      setFormData((prev) => ({
        ...prev,
        cambioInicial: value,
        cambioFinal: formatToTwoDecimals(
          toNumber(formData.ingresosEfectivo) +
            toNumber(value) -
            toNumber(formData.totalCaja)
        ),
      }));
    }
    if (name === "totalCaja") {
      setFormData((prev) => ({
        ...prev,
        totalCaja: value,
        cambioFinal: formatToTwoDecimals(
          toNumber(formData.cambioInicial) +
            toNumber(formData.ingresosEfectivo) -
            toNumber(value)
        ),
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: formatToTwoDecimals(value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Aquí podries fer la crida a la teva API o funció de Firebase
    console.log("Dades enviades:", formData);

    const db = getFirestore();

    const report = {
      ingresosEfectivo: parseFloat(formData.ingresosEfectivo || 0),
      ingresosTarjeta: parseFloat(formData.ingresosTarjeta || 0),
      cambioInicial: parseFloat(formData.cambioInicial || 0),
      cambioFinal: parseFloat(formData.cambioFinal || 0),
      totalCaja: parseFloat(formData.totalCaja || 0),
      comentarios: formData.comentarios || "",
      descuadre: !!formData.descuadre,
      fechaActualizacion: serverTimestamp(),
      email: usuario ? usuario.email : "anónimo",
      usuario: usuario.firstName + " " + usuario.lastName,
    };
    console.log(report);

    const path = `Fila12/Sales/${fecha}/Time/${turno}Reports`;

    setDoc(doc(db, path, "1"), report, { merge: true });

    setShowAlert(true);
    setLastReport(report);
    setTimeout(() => setShowAlert(false), 4000);
  };

  return (
    <>
      <h5> Cash Closing Report</h5>
      {hasLastReport ? (
        <SVCashClosingSummary data={lastReport} fecha={fecha} />
      ) : (
        <Container className="mt-4 mb-5">
          {showAlert && (
            <Alert
              variant="success"
              onClose={() => setShowAlert(false)}
              dismissible
            >
              Informe enviat correctament ✅
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="ingresosEfectivo">
                  <Form.Label>Ingressos en efectiu (€)</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>€</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="ingresosEfectivo"
                      step="1"
                      value={formData.ingresosEfectivo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="ingresosTarjeta">
                  <Form.Label>Ingressos amb targeta (€)</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>€</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="ingresosTarjeta"
                      step="1"
                      value={formData.ingresosTarjeta}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!formData.descuadre}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="cambioInicial">
                  <Form.Label>Canvi inicial (€)</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>€</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="cambioInicial"
                      step="1"
                      value={formData.cambioInicial}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="cambioFinal">
                  <Form.Label>Canvi final (€)</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>€</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="cambioFinal"
                      step="1"
                      value={formData.cambioFinal}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!formData.descuadre}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="totalCaja">
                  <Form.Label>Total guardat a caixa (€)</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>€</InputGroup.Text>
                    <Form.Control
                      type="number"
                      name="totalCaja"
                      step="1"
                      value={formData.totalCaja}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col
                md={6}
                className="d-flex align-items-end justify-content-end mt-3 mt-md-0"
              >
                <Form.Check
                  type="checkbox"
                  label="Hi ha descuadrament?"
                  name="descuadre"
                  checked={formData.descuadre}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Form.Group className="mb-3" controlId="comentarios">
              <Form.Label>Comentaris</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="comentarios"
                value={formData.comentarios}
                onChange={handleChange}
                placeholder="Escriu aquí observacions o incidències..."
              />
            </Form.Group>

            <div className="text-center mt-4">
              <Button variant="primary" type="submit" size="lg">
                Guardar
              </Button>
            </div>
          </Form>
        </Container>
      )}
    </>
  );
}
